module.exports = __webpack_public_path__ + "static/media/close.f6750cd4.svg";